// menu transitions
var megaMenuContents = document.querySelectorAll('.mega-menu__content');

megaMenuContents.forEach(function(megaMenuContent) {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting && entry.target.parentNode.hasAttribute('open')) {
        var textElements = entry.target.querySelectorAll('.mega-menu__link');
        textElements.forEach(function(textElement, index) {
          TweenMax.set(textElement, {
            opacity: 0,
            x: 20,
          });
          TweenMax.to(textElement, 0.5, { // Decreased duration to 0.5 seconds
            opacity: 1,
            x: 0,
            ease: Power4.easeOut,
            delay: 0.1 + index * 0.05, // Decreased delay for faster animation
          });
        });
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0.5,
  });

  observer.observe(megaMenuContent);
});

// page animations
var staggerfadeElements = document.querySelectorAll('.staggerfade-right, .card');

staggerfadeElements.forEach(function(element) {
  element.style.opacity = '0';
  element.style.transform = 'translateX(20px)';
});

var staggerfadeObserver = new IntersectionObserver(function(entries) {
  entries.forEach(function(entry) {
    if (entry.isIntersecting) {
      var textElements = entry.target.querySelectorAll('.staggerfade-right, .card');
      textElements.forEach(function(textElement, index) {
        TweenMax.to(textElement, 1, { // Adjusted duration to 1 second
          opacity: 1,
          x: 0,
          ease: Power4.easeOut,
          delay: 0.5 + index * 0.1, // Adjusted delay for faster animation
        });
      });
    } else if (entry.target.style.opacity === '1') {
      var textElements = entry.target.querySelectorAll('.staggerfade-right, .card');
      textElements.forEach(function(textElement) {
        TweenMax.set(textElement, {
          opacity: 0,
          x: 30
        });
      });
    }
  });
}, { threshold: [0, 1] });

var staggerfadeTriggerDivs = document.querySelectorAll('.collection, .collection-list-wrapper, .pr-product-item, .page-width, .product-recommendations, .blog');
staggerfadeTriggerDivs.forEach(function(triggerDiv) {
  staggerfadeObserver.observe(triggerDiv);
});

// text with image transitions
var imageElements = document.querySelectorAll('.image-with-text__heading, .samples, .wishlist_icon,  .price, .ingredients_popup,  .installment--wrapper-main, .before-cta-des, .breadcrumb-link-main, h3, .optionSize, .product__accordion, .cstm-meta-bread, .cabinet-bar, .breadcrumbs-dot, .image-with-text__text, .image-with-text__media, dl, dd, dt, .product__text, .product__title, .product__tax, .product__description, .price, variant-radios, .product-form__buttons, .carousel-title, .product-form__input,  .button--secondary, .icon-with-text__item, .share-button, .multicolumn-list__item');

imageElements.forEach(function(element) {
  element.style.opacity = '0';
  element.style.transform = 'translateX(20px)';
});

var imageObserver = new IntersectionObserver(function(entries) {
  entries.forEach(function(entry) {
    if (entry.isIntersecting) {
      var textElements = entry.target.querySelectorAll('.product__info-wrapper, .image-with-text__heading, .samples, .wishlist_icon,  .price, .ingredients_popup, .installment--wrapper-main, .before-cta-des, .breadcrumb-link-main, h3, .optionSize, .product__accordion, .cstm-meta-bread, .cabinet-bar, .breadcrumbs-dot, .image-with-text__text, .image-with-text__media, dl, dd, dt, .product__text, .product__title, .product__tax, .product__description, .price, variant-radios, .product-form__buttons, .carousel-title, .product-form__input,  .button--secondary, .icon-with-text__item, .share-button, .multicolumn-list__item');
      textElements.forEach(function(textElement, index) {
        TweenMax.to(textElement, 1.5, { // Adjusted duration to 1.5 seconds
          opacity: 1,
          x: 0,
          ease: Power4.easeOut,
          delay: 0.2 + index * 0.1, // Adjusted delay for faster animation
        });
      });
    } else if (entry.target.style.opacity === '1') {
      var textElements = entry.target.querySelectorAll('.product__info-wrapper, .image-with-text__heading, .samples, .wishlist_icon,  .price, .ingredients_popup, .installment--wrapper-main, .before-cta-des, .breadcrumb-link-main, h3, .optionSize, .product__accordion, .cstm-meta-bread, .cabinet-bar, .breadcrumbs-dot, .image-with-text__text, .image-with-text__media, dl, dd, dt, .product__text, .product__title, .product__tax, .product__description, .price, variant-radios, .product-form__buttons, .carousel-title, .product-form__input,  .button--secondary, .icon-with-text__item, .share-button, .multicolumn-list__item');
      textElements.forEach(function(textElement) {
        TweenMax.set(textElement, {
          opacity: 0,
          x: 30
        });
      });
    }
  });
}, { threshold: [0, 1] });

var imageTriggerDivs = document.querySelectorAll('.banner, .image-with-text, .collection, .pr-product-item, .page-width, .fifty-container, .accordion, .multicolumn, .product__info-wrapper, .dumy_class_test, .txt_collections, .desktop-scroll, .collapsible-content-wrapper-narrow, .myrich-text, .mini-products-list, .total, .login') ;
imageTriggerDivs.forEach(function(triggerDiv) {
  imageObserver.observe(triggerDiv);
});
